<template>
    <div id="network-filter-plan-name" v-if="plans.length === 1">
        <hp5-heading size-selection="xs" tag-selection="p">{{ planName }}</hp5-heading>
    </div>
</template>
<script setup lang="ts">

    const props = defineProps<{
        plans: Array<{ name: string }>
    }>()

    const planName = computed(() => props.plans[0].name)

</script>
`;
